export default __webpack_public_path__ + "static/media/job_offer6_m.6ae53daa.jpg";